import { render, staticRenderFns } from "./ModalAddSupportStaff.vue?vue&type=template&id=0d271ad0"
import script from "./ModalAddSupportStaff.vue?vue&type=script&lang=ts"
export * from "./ModalAddSupportStaff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports